import {Component} from '@angular/core';
import {MembershipPlanResponse} from '../../../../../../@shared/models/response.module';
import {MembershipService} from '../../../../../../@shared/services/membership-service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AQH_MEM_1, AQH_MEM_4} from '../../../../../../@shared/models/input.module';
import {StorageService} from '../../../../../../@core/services/storage.service';

@Component({
  selector: 'app-purchase-membership',
  standalone: false,
  templateUrl: './purchase-membership.html',
  styleUrl: './purchase-membership.css'
})
export class PurchaseMembership {
  plans: MembershipPlanResponse[] = [];
  selectedPlan: MembershipPlanResponse | null = null;
  loading: boolean = false;
  purchasing: boolean = false;

  constructor(private membershipService: MembershipService,
              private storageService: StorageService,
              private modal: NgbActiveModal) {
  }

  ngOnInit() {
    this.loadPlans();
  }

  loadPlans() {
    this.loading = true;
    const params: AQH_MEM_4 = {
      company_id: this.storageService.getSelectedCompanyId()
    };

    this.membershipService.getMembershipPlans(params).subscribe({
      next: (plans) => {
        this.plans = plans;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  selectPlan(plan: MembershipPlanResponse) {
    this.selectedPlan = plan;
  }

  purchaseMembership() {
    if (!this.selectedPlan) return;

    this.purchasing = true;
    const params: AQH_MEM_1 = {
      plan_id: this.selectedPlan.plan_id
    };

    this.membershipService.postMembership(params).subscribe({
      next: () => {
        this.purchasing = false;
        this.modal.close(true);
      },
      error: () => {
        this.purchasing = false;
      }
    });
  }

  close() {
    this.modal.close();
  }

  formatPrice(cents: number): string {
    return (cents / 100).toFixed(2);
  }
}
